import { render } from "./ProductSolution.vue?vue&type=template&id=5f5071b1&scoped=true"
import script from "./ProductSolution.vue?vue&type=script&lang=js"
export * from "./ProductSolution.vue?vue&type=script&lang=js"

import "./ProductSolution.vue?vue&type=style&index=0&id=5f5071b1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f5071b1"],['__file',"src/views/h5/ai/solution/ProductSolution.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f5071b1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f5071b1', __exports__)) {
    api.reload('5f5071b1', __exports__)
  }
  
  module.hot.accept("./ProductSolution.vue?vue&type=template&id=5f5071b1&scoped=true", () => {
    api.rerender('5f5071b1', render)
  })

}


export default __exports__